var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 11H7.66634V9.66668H6.33301V11ZM6.99967 0.333344C3.31967 0.333344 0.333008 3.32001 0.333008 7.00001C0.333008 10.68 3.31967 13.6667 6.99967 13.6667C10.6797 13.6667 13.6663 10.68 13.6663 7.00001C13.6663 3.32001 10.6797 0.333344 6.99967 0.333344ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.94001 1.66634 7.00001C1.66634 4.06001 4.05967 1.66668 6.99967 1.66668C9.93967 1.66668 12.333 4.06001 12.333 7.00001C12.333 9.94001 9.93967 12.3333 6.99967 12.3333ZM6.99967 3.00001C5.52634 3.00001 4.33301 4.19334 4.33301 5.66668H5.66634C5.66634 4.93334 6.26634 4.33334 6.99967 4.33334C7.73301 4.33334 8.33301 4.93334 8.33301 5.66668C8.33301 7.00001 6.33301 6.83334 6.33301 9.00001H7.66634C7.66634 7.50001 9.66634 7.33334 9.66634 5.66668C9.66634 4.19334 8.47301 3.00001 6.99967 3.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.3a3f2fa0fb5d29da7289b86c93ccb350.svg";
export { ForwardRef as ReactComponent };